import { TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PowerUnit } from '../enums'
export interface GeneratorApparentPowerFieldProps extends Omit<TextFieldProps, 'value' | 'type'> {
  value?: number
  unit?: PowerUnit
}

export default function GeneratorApparentPowerField({
  value,
  unit = PowerUnit.KILOVOLT_AMPERE,
  label,
  ...props
}: GeneratorApparentPowerFieldProps) {
  const { t } = useTranslation('generator')

  const defaultLabel = `${t('apparentPower')} (${unit})`

  return (
    <TextField
      type="number"
      label={label ?? defaultLabel}
      value={value}
      variant="outlined"
      fullWidth
      {...props}
    />
  )
}
